<template>
  <div>
    <Dialog :open="open" @close="$emit('close')">
      <template v-slot:title>
        <FlexRow justify="center" full-width>
          <Label text="テンプレート一覧" size="h5" bold />
        </FlexRow>
      </template>
      <v-simple-table>
        <tbody>
        <tr v-for="template in templates" :key="template.id">
          <td>{{template.name}}</td>
          <td style="width: 60px">
            <Button text @click="editTemplate = template">
              <v-icon>mdi-pencil</v-icon>
            </Button>
          </td>
          <td style="width: 60px">
            <Button text @click="deleteTemplate = template">
              <v-icon>mdi-delete</v-icon>
            </Button>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </Dialog>
    <MessageTemplateEditDialog
        :open="editTemplate !== undefined"
        :template="editTemplate"
        :companyId="companyId"
        @close="editTemplate = undefined"
    />
    <MessageTemplateDeleteDialog
        :open="deleteTemplate !== undefined"
        :template="deleteTemplate"
        :companyId="companyId"
        @close="deleteTemplate = undefined"
    />
  </div>
</template>

<script>
import FlexRow from "../atoms/FlexRow";
import Label from "../atoms/Label";
import {mapGetters} from "vuex";
import Dialog from "../atoms/Dialog";
import Button from "../atoms/Button";
import MessageTemplateEditDialog from "./MessageTemplateEditDialog";
import MessageTemplateDeleteDialog from "./MessageTemplateDeleteDialog";
export default {
  name: "MessageTemplateListDialog",
  components: {MessageTemplateDeleteDialog, MessageTemplateEditDialog, Button, Dialog, Label, FlexRow},
  props: {
    open: {
      type: Boolean
    },
    companyId: {
      type: String
    }
  },
  data() {
    return {
      editTemplate: undefined,
      deleteTemplate: undefined
    }
  },
  computed: {
    ...mapGetters("message", ["templates"])
  }
}
</script>

<style scoped>

</style>